import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { WizardActionService } from 'app/main/wizard-actionGO/services/wizard.service';
import Swal from 'sweetalert2';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import * as $ from 'jquery';
import { ModalRecoComponent } from "./modal-reco/modal-reco.component";
import { SurveyCheckComponent } from "./survey-check/survey-check.component";
//SERVICE
import { SheduleService } from "../../services/shedule.service";
import {CountdownComponent} from 'ngx-countdown';
import { AuthService } from 'app/auth/auth.service';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { LeaderEditEmaService } from 'app/main/wizard-leader/services/leaderEditEma.service';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

const momentTz = require('moment-timezone');

@Component({
  selector: 'vista-gen',
  templateUrl: './vista-gen.component.html',
  styleUrls: ['./vista-gen.component.scss'],
  animations   : fuseAnimations
})
export class VistaGenComponent implements OnInit {

  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @ViewChild('fecRecordatorio', { read: undefined }) calReco: MatDatepicker<Date>;
  // @ViewChild('cd', { static: false }) countdown: CountdownComponent;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;
  idEmpresa=localStorage.getItem('companyID');
  idProducto=localStorage.getItem('productoID');

  idiomaActual:string;
  instituto: number;

  cards= catalogo.cards;
  secciones = catalogo.secciones;

  logoOK: boolean;
  reqTecOK: boolean;

  idFechaLanzamiento: string;
  fechaLanzamiento: any;
  fechaCierre: any;
  fechaCierreValidacion: any;
  fechasRecordatorios: any[] = [];

  numSecciones = 0;
  seccionesCompletas = 0;
  indices:any[] = [];
  creandoEncuesta: boolean;
  tamanioTagSecc: number;
  progresoEncuesta = 0;
  procesoActual: string;
  procesoFinalizado: boolean;
  procesoOK = true;
  //variable que permite modifcar la fecha de cierre de la encuesta


  filtroLanzamiento = (d: Date | null): boolean => {
    var moment = require('moment');
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };
  filtroRecordatorios: any;
  prorrogasEncuesta:any;
  prorrogas=false;
  cierreEditable = false;
  token:any;
  datosSurveyCheck:any;

  configCD: any = {
    demand: true,
    format: 'HH:mm:ss',
    leftTime: 0
  }
  tiempoRestante = 0;

  recordatoriosPermitidos = 1000; //tomar de variable despues
  fechaRecoTemp: any;

  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;

  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  desbloqueoEstatus:boolean=false;
  nameUserAdmin:any="";
  nivelNotificacion:number;

  constructor(
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private programacionService: ProgramacionService,
    private encuestaService: EncuestaService,
    private wizardService: WizardService,
    private wizardLeaderService: WizardActionService,
    private sheduleService: SheduleService,
    private surveyServ: SurveyStatusService,
    public authService: AuthService,
    private idiomasService: IdiomasService,
    private leaderEditService: LeaderEditEmaService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.programacionService.ordenProg.subscribe( (resu) => {
      console.log("se envio orden desde navbar: ",resu);
      this.logoOK = true;
      // if(this.logoOK && this.reqTecOK){
      //   this.cards[0].completo = true;
      // }
    });
    this.cards[0].completo = false;  //se desacompleta el paso 1 de seleccion de fecha

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
      this.nameUserAdmin=this.userData.user;
    }
    else{
      this.validationUser=false;
      this.nameUserAdmin="";
    }
    }
  }

  ngOnInit() {
    this.getInstituto();
    this.obtieneCertificarActual();

  }



  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
  }

  cargaLogoEmpresa(){
    this.programacionService.enviaNavbar("hola prro");
  }

  reiniciarVariables(){
    this.secciones.forEach(seccion => {
      seccion.completo = false;
      seccion.fallo = false;
    });
    this.tamanioTagSecc = 0;
    this.progresoEncuesta = 0;
    this.procesoActual = "";
    this.procesoFinalizado = false;
    this.procesoOK = true;
  }

  traduceTextosTS(){
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }




  verRecordatorios(){
    if(this.fechaLanzamiento){
      const dialogRef = this.dialog.open(ModalRecoComponent, {
        width: '50%',
        data: {
          tipo: 'recordatorios',
          fechasRecordatorios: this.fechasRecordatorios,
          instituto: this.instituto
        }
      });
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LISTARECOBEF'), 3);
    }
  }

  surveyCheckService(){
    if(this.token){
    this.programacionService.surveyCheck(this.token).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
    });
    }
  }

  surveyCheck(){
    const dialogRef = this.dialog.open(SurveyCheckComponent, {
      width: '40%',
      data: {
        datos: this.datosSurveyCheck
      }
    });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.leaderEditService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.token=producto.tokenConfig;
              // this.surveyCheckService();
              //obtiene el status del paso adicionales del certificar vigente
              this.leaderEditService.getStatusEmailEdit(localStorage.getItem('productoID')).subscribe( (data: backInter.getStatusIndiv) => {
                if(data.estatus === 3)
                  this.pasoCompleto = true;
              });
              this.idiomasService.getNivelNotificacionCatServ(this.instituto).subscribe( (data: any) => {
                console.log('entro get catalogo niveles notificaciones',data);
                this.nivelNotificacion=data.catlNotificationBroker[0].secciones.programacion.levelNotification;
                console.log('this.nivelNotificacion::',this.nivelNotificacion);
              });
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };


      // this.getStatusModal();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }





  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '11': case 'BR': this.instituto = 11; break;
      case '14': case 'GCTI': this.instituto = 14; break;
      case '15': case 'ES': this.instituto = 15; break;
    }
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instituto);
    this.filtraInstitutoVisible();
  }

  filtraInstitutoVisible(){
    let institutosPermitidos = [2,3,4,5,6,11,14,15];
    if(institutosPermitidos.includes(this.instituto)){
      // this.cards[1].visible = true;
      // this.cierreEditable = true;
    }
  }


  completarPaso(){
    console.log("entro");
    if(this.pasoCompleto){
      //this.aletaRestric('PROGRAMACION.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
    }else{
      // if(this.procesoFinalizado && this.procesoOK){
        this.aletaRestric('PROGRAMACION.COMPLETAR',true);
      // }
    }

  }
  enviaOrdenWizard(){
    this.wizardLeaderService.puenteDatosActionGo("100"); //100 = actualiza los status de los steps
  }

  desbloquearProgramacion(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.TITULO_DESBLOQUEAR2';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePasProgra',
            productoId:this.productoCertificar.idCertificar,
            programacion: 2,
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,
          }
          this.programacionService.DesbloquearPasoProgramacion(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '215'){
               this.pasoCompleto = false;
               this.enviaOrdenWizard();
               this.openSnackBar(succes,"OK");
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,

               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,

        confirmButtonText: cerrar,
        })
      }
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'LEADER_GO.SECCION_PROGRAMACION.MODAL_CONFI_COMPL';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'completePasProgra',
            productoId:this.productoCertificar.idCertificar,
            emailEdit: 3,
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,

          }
          this.programacionService.guardaStatusProgramacion(datos).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '219'){
              //this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
              // let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
              // this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
              // this.openSnackBar(textoMensaje,"OK");
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }



}
